module.exports = __webpack_public_path__ + "img/baitiao_water.b485952e.png";